<script lang="ts" setup>
import type { PropertyFilterDto } from "~~/server/api/ecom/products/search.post";
import type { CatalogPageRecord, LayoutRecord } from "~~/server/graphql/datocms/generated";
import { z } from "zod";

const layout = await useLayout();
const cmsData = await useCatalogPage();

if (!layout || !cmsData || !cmsData.value) {
  throw create404Error();
}

const paramsSchema = z.object({
  slugs: z.string().optional().or(z.string().array().optional()),
});

const { params } = useRoute();
const { data: validParamsData } = paramsSchema.safeParse(params);

const categories = await useCategories();

const currentCategoryPath = Array.isArray(validParamsData?.slugs) ? `/${validParamsData?.slugs?.join("/")}` : null;
const currentCategory = currentCategoryPath ? categories.tree.getByPath(currentCategoryPath) : null;

if (currentCategory) {
  useCategorySlugsToI18n(categories.tree, currentCategory);
}
else {
  useFixedSlugsToI18n("");
}

const propertyFilterList = Array.isArray(cmsData.value.happyDealsPropertyFilter)
  ? [JSON.parse(cmsData.value.happyDealsPropertyFilter.at(0).value) as PropertyFilterDto]
  : undefined;
</script>

<template>
  <div v-if="layout && cmsData">
    <ProductSearchBase
      :layout="layout as LayoutRecord"
      :cms-data="cmsData as CatalogPageRecord"
      :page-title="cmsData.happyDealsCategoryTitle"
      :category="currentCategory"
      :filter="{ propertyFilterList }"
      :show="{ categoryDrilldown: true }"
    />
  </div>
</template>

<style scoped>

</style>
